import { Box, Table, Tooltip } from "@procore/core-react";

import { highlightText } from "utils/textHighlight";
import { useIsTruncated } from "utils/truncatedText";

interface PropertyRowProps {
    propertyName: string;
    propertyValue: string;
    searchTerm: string;
    isSelected: boolean;
    onToggleSelection: () => void;
}

const TruncatedCell = ({ content, searchTerm }: { content: string; searchTerm: string }) => {
    const { ref, isTruncated } = useIsTruncated();

    const cellContent = (
        <Table.TextCell
            ref={ref}
            style={{
                display: "block",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "100%",
            }}
        >
            {highlightText(content, searchTerm)}
        </Table.TextCell>
    );

    // Always wrap in Tooltip, but only show content when truncated
    return (
        <Tooltip overlay={isTruncated ? <Tooltip.Content>{content}</Tooltip.Content> : <span></span>} placement="top">
            {cellContent}
        </Tooltip>
    );
};

export function PropertyRow({
    propertyName,
    propertyValue,
    searchTerm,
    isSelected,
    onToggleSelection,
}: PropertyRowProps) {
    return (
        <Table.BodyRow>
            <Table.BodyCell style={{ maxWidth: "200px" }}>
                <Box display="flex" alignItems="center" gap="sm">
                    <Table.Checkbox
                        checked={isSelected}
                        onChange={onToggleSelection}
                        aria-label={`Select ${propertyName}`}
                    />
                    <TruncatedCell content={propertyName} searchTerm={searchTerm} />
                </Box>
            </Table.BodyCell>
            <Table.BodyCell style={{ maxWidth: "250px" }}>
                <TruncatedCell content={propertyValue} searchTerm={searchTerm} />
            </Table.BodyCell>
        </Table.BodyRow>
    );
}
